import { ft } from './utils';

export default {
  dialogDirection: 'rtl',
  dialogType: 'drawer',
  dialogWidth: '50%',
  border: true,
  stripe: true,
  index: true,
  indexLabel: ft('i18n_common_serial_number', '序号'),
  labelPosition: 'top',
  page: false,
  align: 'left',
  menuAlign: 'left',
  menuWidth: '180',
  menuType: 'text',
  addBtn: true,
  header: false,
  addBtnText: ft('i18n_common_add_details', '新增行'),
  simplePage: true,
  size: 'mini',
  refreshBtn: false,
  searchBtn: false,
  filterBtn: false,
  columnBtn: false,
  column: []
};
